import { createFileRoute } from '@tanstack/react-router';

import { StudentAssessmentsPage } from '@/features/student/StudentAssessmentsPage';
import { requireRole } from '@/lib/routeGuards';

export const Route = createFileRoute('/_authed/assessments')({
  beforeLoad: () => requireRole('student'),
  component: StudentAssessmentsPage,
});
